import { Yup } from '@frontman/utils';

export const disabilityInsuranceTypeSchema = Yup.object().shape({
  typeOfDisabilityInsurancePossessed: Yup.mixed()
    .oneOf(['short_term', 'long_term', 'both', 'not_sure'])
    .required('Please select an option'),
});
